// personalSelectors.js
import { createSelector } from "@reduxjs/toolkit";
import { calcDailyCalories } from "../utils/calcCalories";
import { calcTargetCalories } from "../utils/calcTargetCalories";

const selectPersonal = state => state.personal;

export const selectProfile = state => state.personal.profile;
export const selectSprint = state => state.personal.sprint;

// export const selectTodayWeight = createSelector(
//   state => state.personal.byDate,
//   selectProfile,
//   (byDate, profile) => {
//     const today = new Date().toISOString().split("T")[0];
//     return byDate[today]?.weight || profile.baseWeight;
//   }
// );

export const selectTodayWeight = createSelector(
  state => state.personal?.byDate || {},
  state => state.personal?.profile || {},
  (byDate, profile) => {
    const today = new Date().toISOString().split("T")[0];

    return byDate[today]?.weight ?? profile.baseWeight ?? 0;
  }
);

export const selectMaintenanceCalories = createSelector(
  selectProfile,
  selectTodayWeight,
  (profile, weight) => {
    if (!weight) return null;
    return calcDailyCalories(profile, weight);
  }
);

export const selectTargetCalories = createSelector(
  selectProfile,
  selectTodayWeight,
  selectSprint,
  (profile, weight, sprint) => {
    if (!weight) return null;
    return calcTargetCalories(profile, weight, sprint);
  }
);